// Libraries
import React from 'react';
// Components
import { ButtonGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Menu from '../MenuButton/Menu';
// Utils
import { useStyles } from './style';
import { MenuDirection, MenuPlacement } from '../MenuButton';
/**
 * @deprecated
 * Use `ButtonMenuGroup` to render a button with dropdown group
 */
function ButtonMenuGroup(props) {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var style = props.style, disabled = props.disabled, variant = props.variant, items = props.items, size = props.size, elementId = props.elementId;
    var anchorRef = React.useRef(null);
    var toggleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    var VisibleButton = null;
    var classes = useStyles(style);
    var _b = items.reduce(function (splitItemsObj, item) {
        if (!item.buttonOption) {
            splitItemsObj.menuItems.push(item);
        }
        else {
            Object.assign(splitItemsObj, { buttonItem: item });
        }
        return splitItemsObj;
    }, { buttonItem: null, menuItems: [] }), buttonItem = _b.buttonItem, menuItems = _b.menuItems;
    // button
    if (buttonItem) {
        var label = buttonItem.label, Icon = buttonItem.icon, action = buttonItem.action;
        VisibleButton = (React.createElement(Button, { onClick: action, disabled: disabled, size: size, disableRipple: true, "data-testid": 'buttonMenuGroup_visibleButton', classes: {
                root: classes.root,
            } },
            Icon && React.createElement(Icon, { className: classes.icon, "data-testid": 'buttonMenuGroup_visibleButton_icon' }),
            React.createElement("span", { className: classes.span, "data-testid": 'buttonMenuGroup_visibleButton_label' }, label)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonGroup, { ref: anchorRef, variant: variant, color: 'primary', "aria-label": 'split button', disableRipple: true, style: style, "data-testid": elementId, disableElevation: true },
            VisibleButton,
            menuItems.length && (React.createElement(Button, { color: 'primary', onClick: toggleOpen, disabled: disabled, size: size, "data-testid": 'buttonMenuGroup_arrowDownButton', className: classes.dropDownIconButton },
                React.createElement(ArrowDropDownIcon, null)))),
        open && (React.createElement(Menu, { "data-testid": 'buttonMenuGroup_menu', open: open, anchorEl: anchorRef.current, items: menuItems, menuDirection: MenuDirection.Below, menuPlacement: MenuPlacement.Right, onClose: handleClose }))));
}
ButtonMenuGroup.defaultProps = {
    variant: 'contained',
    elementId: 'ButtonMenuGroup',
    size: 'small',
};
export default ButtonMenuGroup;
//# sourceMappingURL=ButtonMenuGroup.js.map